import { useEffect, useState } from "react";
import { getMagazineCategoriesUseCase } from "../useCases/getMagazineCategoriesUseCase";
import { useTable } from "src/hooks/useTable";
import { useDebounce } from "src/hooks/useDebounce";

export const useMagazineCategoriesTable = () => {
    const [loading, setLoading] = useState(false);
    const { rowsPerPage, page, search, onSearch, onChangePage, onChangeRowsPerPage, scrollRef } = useTable();

    useEffect(() => {
        onGetList();
    }, [rowsPerPage, page])

    useEffect(() => {
        debouncedWrapper();
    }, [search])

    const onGetList = async () => {
        if (!loading) {
            setLoading(true);
            await getMagazineCategoriesUseCase({ limit: rowsPerPage, offset: page * rowsPerPage, search });
            setLoading(false);
        }
    }

    const { debouncedWrapper } = useDebounce(onGetList, 500)

    return { rowsPerPage, page, search, onSearch, onChangePage, onChangeRowsPerPage, scrollRef };
}